<template>
  <div class="data-container">
    <img src="https://files.wondercv.com/company/privacy-company-zero.png" alt="">
    <span class="title">{{ title }}</span>
    <slot name="content" />
  </div>
</template>

<script>
export default {
  name: "Index",
  props: {
    title: {
      type: String,
      default: "数据被风刮跑了~",
    }
  }
}
</script>

<style lang="scss" scoped>
.data-container {
  width: 100%;
  height: 498px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  img {
    width: 88px;
    height: 88px;
    border-radius: 44px;
  }
  .title {
    margin-top: 20px;
    font-size: 12px;
    color: #606060;
  }
}
</style>